import { colors } from './constants';
import { styled } from './styled';

export const Shine = styled.span`
  display: block;
  background: ${colors.BORDER_GRAY};
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  border-radius: 3px;
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
  height: 15px;
  margin-top: 0.3125rem;
  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }
`;

export const Hidden = styled.span`
  visibility: hidden;
`;

export const HideOnMobile = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const HideOnDesktop = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
